$(document).ready(function () {
    var e;
    -1 === window.location.href.indexOf("?") && $.ajax({ url: "/cart/update.js", type: "POST", data: { note: "" }, success: function (e) { } }),
        -1 < window.location.href.indexOf("pageno") && ((e = document.location.href.split("=").pop()), $.ajax({ url: "/cart/update.js", type: "POST", data: { note: "pageno=" + e }, success: function (e) { } })),
        $(".show-all").click(function (e) {
            e.preventDefault(),
                $(this).prop("disabled") ||
                ($.ajax({ url: "/cart/update.js", type: "POST", data: { note: "" }, success: function (e) { } }),
                    setTimeout(() => {
                        var e = $("body").find("#shop_page_url").val();
                        window.location = e;
                    }, 1e3));
        }),
        $("select#dynamic_select").change(function () {
            var e,
                t = $(this).val(),
                o = $(location).attr("href");
            return (
                -1 != o.indexOf("?")
                    ? ((o = (e =
                        -1 != (e = -1 != (e = o + "&sort=" + t).indexOf("sort=ascending") && "descending" == t ? o.replace("sort=ascending", "sort=descending") : e).indexOf("sort=descending") && "ascending" == t
                            ? o.replace("sort=descending", "sort=ascending")
                            : e).split("?")[1]),
                        $.ajax({
                            url: "/cart/update.js",
                            type: "POST",
                            data: { note: o },
                            success: function (e) {
                                console.log(e);
                            },
                        }))
                    : ((e = $("#shop_page_url").val() + "?sort=" + t),
                        $.ajax({
                            url: "/cart/update.js",
                            type: "POST",
                            data: { note: "sort=" + t },
                            success: function (e) {
                                console.log(e);
                            },
                        })),
                setTimeout(() => {
                    window.location = e;
                }, 1e3),
                !1
            );
        }),
        $(window).width() < 768 &&
        ($(".search-control").click(function () {
            $("body").find(".mobile-search").css("transform", "translate(0)"), $("body").find(".mobile-search").css("opacity", "1"), $("body").find(".mobile-search").show();
        }),
            $(".close-btn").click(function () {
                $("body").find(".mobile-search").css("transform", "inherit"), $("body").find(".mobile-search").css("opacity", "0"), $("body").find(".mobile-search").hide();
            }));
}),
    $(document).ready(function () {
        $(".show-all").click(function (e) {
            e.preventDefault(),
                $.ajax({ url: "/cart/update.js", type: "POST", data: { note: "" }, success: function (e) { } }),
                setTimeout(() => {
                    var e = $("body").find("#shop_page_url").val();
                    window.location = e;
                }, 1e3);
        }),
            $(".search-value").keypress(function (e) {
                var t, o, a;
                13 == e.which &&
                    ((t = $(this).val()),
                        -1 != (o = $(location).attr("href")).indexOf("?")
                            ? ((e = (a = o + "&search=" + t).split("?")[1]),
                                $.ajax({
                                    url: "/cart/update.js",
                                    type: "POST",
                                    data: { note: e },
                                    success: function (e) {
                                        console.log(e);
                                    },
                                }),
                                setTimeout(() => {
                                    window.location = a;
                                }, 1e3))
                            : ($.ajax({
                                url: "/cart/update.js",
                                type: "POST",
                                data: { note: "search=" + t },
                                success: function (e) {
                                    console.log(e);
                                },
                            }),
                                setTimeout(() => {
                                    var e = o + "?search=" + t;
                                    return e && (window.location = e), !1;
                                }, 1e3)));
            });
    });
